/**
 * Created by forbiz on 2021-02-25.
 */

import Swiper from 'swiper/dist/js/swiper'

const monthStoryList = () => {
    const $document = $(document);
    
    const storyTabManu = () => {
        const $target = $('.story__tabmenu .swiper-container');
        var totalWidth = 0;

        $('.story__tabmenu .swiper-container .swiper-slide').each(function(){
            totalWidth = totalWidth + $(this).width();
        });

        if( totalWidth >= '1100' ){
            $target.append("<div class='swiper-button-next'></div>\n<div class='swiper-button-prev'></div>");

            const $slider = new Swiper($target, {
                slidesPerView: 'auto',
                grabCursor: true,
                paginationClickable: true,
                navigation: { 
                    nextEl: '.swiper-button-next', 
                    prevEl: '.swiper-button-prev', 
                }
            });
        }
    };

    const monthStoryList_init = () => {
        //storyTabManu();
    };

    window.storyTabManu = storyTabManu;
};

export default monthStoryList;